// extracted by mini-css-extract-plugin
export default {"forgotPassword":"LoginView_forgotPassword__88M2n","signupCard":"LoginView_signupCard__PA5hF"};